//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Swiper from "swiper";
import axios from "axios";
import pager from "@/components/pager.vue";
export default {
  components: { pager },
  name: "new",
  data() {
    return {
      pageSize: 10,
      pageNo: 1,
      idx: 3,
      new_list: [],
      banner: [],
      nav: [
        {
          text: "首页",
          status: "0",
        },
        {
          text: "关于中启",
          status: "1",
        },
        {
          text: "工程案例",
          status: "2",
        },
        {
          text: "新闻中心",
          status: "3",
        },
        {
          text: "业务中心",
          status: "4",
        },
        {
          text: "人力资源",
          status: "5",
        },
        {
          text: "联系我们",
          status: "6",
        },
      ],
    };
  },
  created: function () {},
  updated() {
    new Swiper(".swiper1", {
      spaceBetween: 30,
      centeredSlides: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  },
  mounted() {
    const _this = this;
    _this.getbanner();
    _this.list();
  },
  methods: {
    getbanner() {
      const _this = this;
      _this.$get("/header/banner/fetchOne/NEWSCenter").then((res) => {
        console.log(res);
        _this.banner = res.data;
      });
    },
    list() {
      const _this = this;
      var data = {
        pageNum: 1,
        pageSize: 10,
      };
      _this.$post("/header/news/list", data).then((res) => {
        console.log(res.data.pages);
        _this.pageSize = res.data.pages;
        console.log(_this.totalCount);
        _this.new_list = res.data.list;
      });
    },
    collect_click() {
      alert("请按住Ctrl+D收藏网站");
    },
    new_details(a) {
      this.$router.push({
        path: "/newdetails",
        query: {
          id: a,
        },
      });
    },
    //导航跳转
    rout(a) {
      if (a == 0) {
        this.$router.push({
          path: "/",
        });
      } else if (a == 1) {
        this.$router.push({
          path: "/about",
        });
      } else if (a == 2) {
        this.$router.push({
          path: "/project",
        });
      } else if (a == 3) {
        this.$router.push({
          path: "/new",
        });
      } else if (a == 4) {
        this.$router.push({
          path: "/business",
        });
      } else if (a == 5) {
        this.$router.push({
          path: "/recruit",
        });
      } else if (a == 6) {
        this.$router.push({
          path: "/contact",
        });
      }
    },
    jump(id) {
      const _this = this;
      var data = {
        pageNum: id,
        pageSize: 10,
      };
      _this.$post("/header/news/list", data).then((res) => {
        console.log(res);
        _this.totalCount = res.data.pages;
        _this.new_list = res.data.list;
      });
    },
    getTableData() {},
    //鼠标移入事件
    enter(a) {
      const _this = this;
      var new_list = _this.new_list;
      new_list[a].status = 1;
    },
    //鼠标移出事件
    leave(a) {
      const _this = this;
      var new_list = _this.new_list;
      new_list[a].status = 0;
    },
    //tab点击事件
    tab_click(a) {
      const _this = this;
      _this.goodsstatus = a;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/new.vue